import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class TrainRunsAdminService extends BaseService<any> {
  constructor() {
    super(`train-runs`);
  }

  // Состав рейса (прицепки вагонов).
  getComposition = (runID: string | number) =>
    appAxios.get(`${this.pathWithOrg()}/${runID}/composition`);

  // Полная замена состава. items: [{ wagonID, position?, fromStationID?, toStationID? }]
  setComposition = (runID: string | number, items: any[]) =>
    appAxios.put(`${this.pathWithOrg()}/${runID}/composition`, { items });
}

export default new TrainRunsAdminService();
